import React from 'react';
import '../facet.css';
const FacetSingleSelectComponent = ({ facetOptionResults, filterSelectedOption, loading }) => (
    <React.Fragment>
        {loading ? (
            // Skeleton loading elements
            <div className="sd-facet-skeleton">
                <div className="sd-facet-skeleton-text"></div>
                <div className="sd-facet-skeleton-text"></div>
                <div className="sd-facet-skeleton-text"></div>
            </div>
        ) : (
            // Actual facet options
            facetOptionResults.map((option, index) => (
                <div className="sd-py-2 sd-pr-2" key={index}>
                    <label aria-labelledby={`capacity-heading capacity_val${index + 1}`}>
                        <input
                            type="checkbox"
                            name={`option.docType_${index + 1}`}
                            id={`capacity_val${index + 1}`}
                            checked={option.selected}
                            onChange={() => filterSelectedOption(option)}
                            onClick={() => filterSelectedOption(option)}
                        />
                        <p className="sd-pl-2 sd-w-full sd-mb-0 sd-capitalize">
                            {option.docType} {'('}<span>{option.docCount ? `${option.docCount}` : ''}</span>{')'}
                        </p>
                    </label>
                </div>
            ))
        )}
    </React.Fragment>
);

export default FacetSingleSelectComponent;